import '../styles/landing.css'

export default function About() {
  return (
    <section id="about" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>¿Qué es Ascensos App Vortex?</h2>
          <p style={{ maxWidth: '700px', margin: '0 auto' }}>
            La herramienta definitiva para el personal naval y militar que busca ascender en
            SEMAR, Guardia Nacional o SEDENA.
          </p>
        </div>

        <div className="grid grid-3">
          {[
            { icon: '/icons/captain.png', title: 'Prepárate día a día', text: 'Si lo que quieres es ascender, necesitas 3 cosas: Disciplina, Constancia y la app de Vortex.' },
            { icon: '/icons/books.png',   title: 'Planifica tu estudio', text: 'Define objetivos claros y medibles, así podrás ver tu avance en tiempo real.' },
            { icon: '/icons/read.png',    title: 'Celebra tus logros',   text: 'Crea un horario de estudio y aprovecha tu tiempo: usa el celular para estudiar.' },
          ].map(({ icon, title, text }) => (
            <div key={title} className="icon-card">
              <div className="icon-circle">
                <img src={icon} alt={title} style={{ width: '55px' }} />
              </div>
              <h3 style={{ marginBottom: 'var(--spacing-sm)' }}>{title}</h3>
              <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>{text}</p>
            </div>
          ))}
        </div>

        <div className="about-banner">
          <h3>
            Diseñada para todo el personal, ya sea que vengas en promoción, adecuación o cambio de situación.
          </h3>
          <p>
            Ascensos App Vortex está diseñada para dedicar tu tiempo a tus estudios, combinando las
            herramientas de audios, cuestionarios, resúmenes y el simulador de examen de Ascensos App
            Vortex con tecnologías de vanguardia que usan Inteligencia Artificial para maximizar tu
            aprendizaje. El contenido se adapta a tu institución, jerarquía, cuerpo o servicio y
            especialidad, para que estudies exactamente lo que necesitas — Vortex te ofrece las
            herramientas para hacerlo a tu ritmo, generar cuestionarios en segundos, acceder a un
            asistente digital para tus dudas y convertir tus apuntes en audios listos para escuchar.
          </p>
        </div>
      </div>
    </section>
  )
}